module.exports = __webpack_public_path__ + "static/img/6.173bc6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/6.png
// module id = zHPO
// module chunks = 0